import { TiVoTargets } from "hooks/tivoApps";

import { TiVoDeviceOem, TiVoDevicePlatform } from "./types";

export const getOems = (
  platforms: TiVoDevicePlatform[] = [],
  targets?: TiVoTargets
): TiVoDeviceOem[] => {
  if (!platforms || platforms.length === 0) {
    return [];
  }
  const platformData = platforms.find((platform) =>
    targets?.platforms?.includes(platform.id)
  );
  if (targets?.oems && targets.oems.length > 0) {
    return (platformData?.oems || []).filter((oem) =>
      targets?.oems?.includes(oem.id)
    );
  }
  return platformData?.oems || [];
};
